<template>
  <v-card class="my-3 cardWorld" elevation="0">
    <v-row class="wrapperBox" no-gutters>
      <v-col cols="12" md="2"
        class="justify-center radius-5 colFlag"
        v-if="isFlag"
      >
        <div class="d-flex maskBox pa-2 flex-column align-center text-center">
          <span class="wrapperBox__title mb-1">{{ data.country.name }}</span>
          <CountryFlag
            :icon="data.country.id.toLowerCase()"
            size="big"
            class="mt-0"
          />
        </div>
      </v-col>
      <v-col
        cols="12" md="10"
        class="d-flex justify-space-between radius-5 px-md-3"
      >
        <div class="maskBox px-4 d-flex align-center">
          <v-row no-gutters class="py-4">
            <v-col cols="12" md="8">
              <div class="boxedContent d-flex">
                <!-- group flag and avatar -->
                <div class="boxedContent__group">
                  <AvatarComponent
                    size="71"
                    :url="pictureUrl(data.picture)"
                    :contain="true"
                    class="containImg"
                  />
                  <div class="justify-center radius-5 colFlagMobile"
                    v-if="isFlag"
                  >
                    <div class="d-flex maskBox pa-2 flex-column align-center text-center">
                      <span class="wrapperBox__title mb-1">{{ data.country.name }}</span>
                      <CountryFlag
                        :icon="data.country.id.toLowerCase()"
                        size="big"
                        class="mt-0"
                      />
                    </div>
                  </div>
                </div>
                <!-- end group flag and avatar -->
                <div class="mx-4">
                  <p class="font-weight-bold ml-md-2 cardWorld__title">
                    {{ nameRanking ? '' : `${getIdxCourse(idx, currentTop)}.` }} {{ data.name }}
                  </p>
                  <p v-if="nameRanking"
                    class="ml-md-2 body-2 mb-1">
                    {{nameRanking}}
                  </p>
                  <p class="ml-md-2 cardWorld__subTitle mb-0">
                    {{ data.state }} - {{ data.city }}
                  </p>
                </div>
              </div>
            </v-col>
            <v-col cols="12"
              md="4"
              class="d-flex align-center justify-center mt-md-0 mt-6 mb-md-0 mb-3"
            >
              <div class="boxedContent d-flex" style="position: relative">
                <router-link
                  :to="{name: 'courses.home',
                    params: {
                    coursesCountry: data.country.slug,
                    namegolf: data.slug,
                    }
                  }"
                  class="btnSeemore text-md-subtitle-2 body-2">
                  <translate>See more</translate>
                  <v-icon class="fal fa-arrow-right-long ml-3" color="primary" size="25"></v-icon>
                </router-link>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          v-if="isDelete"
          icon
          color="#000"
          @click="deleteData(data)"
          style="right: 10px; top: 0px; position: absolute; color: #424242"
        >
          <v-icon size="15">fas fa-xmark</v-icon>
        </v-btn>
      </template>
      <translate>Delete</translate>
    </v-tooltip>
    </v-row>
  </v-card>
</template>
<script>
import CountryFlag from "@/components/CountryFlag";
export default {
  name: "CardRanking",
  props: ["isFlag", "data", "idx", "isDelete", "currentTop"],
  components: { CountryFlag },
  computed: {
    nameRanking() {
      const item = this.data || {}
      if(item.countryRank && item.countryRankName) {
        return this.$gettextInterpolate(
          this.$gettext("Rank %{rank} in %{name}"),
            { rank: item.countryRank, name: item.countryRankName }
          );
      } else return ""
    }
  },
  methods: {
    deleteData(data) {
      this.$emit("deleteGolfCourse", data);
    },
    getIdxCourse(idx, currentTop) {
      if(currentTop <= 50) {
        return idx + (currentTop - 10)
      } else if(currentTop == 100) {
        return idx + (currentTop - 50)
      } else if(currentTop >= 200 && currentTop < 1000) {
        return idx + (currentTop - 100)
      } else if (currentTop == 1000) {
        return idx + (currentTop - 500)
      } else {
        return idx
      }
    }
  }
};
</script>
<style lang="scss">
.wrapperBox {
  .maskBox {
    position: relative;
    width: 100%;
  }
}
</style>

